<template>
  <div style="background: #F2F2F2;">
    <div class="topBox">
      <div @click="goBack"><i class="el-icon-arrow-left" style="font-size: 22px;"></i></div>
      <div>详情</div>
      <div></div>
    </div>
    <div>
      <div class="conTBox">
        <div style="font-weight: bold;">
          <span class="userName">
            {{ mZPrescriptionInfo.mzPrescriptionOut.patientName ? mZPrescriptionInfo.mzPrescriptionOut.patientName : '无' }}
          </span>
          <span style="margin-left:20px">
            <span v-if="patientId">{{ mZPrescriptionInfo.mzPrescriptionOut.sex ? '男' : '女' }},</span><span v-else>无,</span>
          </span>
          <span style="margin-left:10px">{{ mZPrescriptionInfo.mzPrescriptionOut.age ? mZPrescriptionInfo.mzPrescriptionOut.age + '岁' : '无' }}</span>
           <!-- <span><i class="el-icon-phone t2"></i>：{{ mZPrescriptionInfo.mzPrescriptionOut.patientPhone ? mZPrescriptionInfo.mzPrescriptionOut.patientPhone : '无' }}</span> -->
        </div>
        <div>
          <span class="titleName">诊断：</span><span>{{ detailInfo.diagnoseResult ? detailInfo.diagnoseResult : '无' }}</span>
        </div>
        <div>
          <span class="titleName">就诊时间：</span><span>{{ mZPrescriptionInfo.mzPrescriptionOut.addTime | timefilters }}</span>
        </div>
        <div>
          <span class="titleName">看诊医生：</span>
          <span>{{ detailInfo.doctorName ? detailInfo.doctorName : '无' }}</span>
          <span v-if="mZPrescriptionInfo.mzPrescriptionOut.userPhone">【{{ mZPrescriptionInfo.mzPrescriptionOut.userPhone }}】</span>
        </div>
        <div>
          <span class="titleName">审核医生：</span>
          <span>{{ mZPrintPrescription.doctorName ? mZPrintPrescription.doctorName : '无' }}</span>
          <span v-if="mZPrintPrescription.doctorPhone">【{{ mZPrintPrescription.doctorPhone }}】</span>
        </div>
      </div>
    </div>
    <div class="conTBox" style="margin-top:10px">
        <div>
          <span >取药方式：</span>
          <span class="titleNameSelef" v-if="detailInfo.isSelef">自取</span>
          <span class="titleNameSelef" v-else>快递</span>
        </div>
        <div v-if="!detailInfo.isSelef">
          <span class="titleNameSelef">{{ detailInfo.takeAddress ? detailInfo.takeAddress : '无' }}</span>
        </div>
    </div>
    <div class="conTBox" style="margin-top:10px" v-if="mzPrescriptionYP.length > 0">
        <div>
          <div style="font-weight: bold;">方剂处方</div>
        </div>
        <div v-for="(item,YP) in mzPrescriptionYPNames" :key="YP">
          处方名：<span>{{YP ? YP : '无'}}</span>
          <div v-for="(itemYP,indexYP) in item" :key="indexYP">
            <div>
              <div>
                <span class="titleNameSelef">{{itemYP.entityName?itemYP.entityName:'无'}},</span>
                <span style='margin:0 10px'>规格:{{ itemYP.specification?itemYP.specification:'无'}},</span>
                <span>剂数：{{ itemYP.dosage ? itemYP.dosage : '' }}</span>
              </div>
              <div>
                <span>{{ itemYP.money?itemYP.money.toFixed(2):'无'}}/{{ itemYP.isSeparate ? itemYP.separateNumberUnit : itemYP.specificationUnit}}</span>
                <span style='margin:0 5px'>×</span>
                <span>{{ itemYP.amount?itemYP.amount:'无'}}</span>
                <span style='margin:0 5px' >=</span>
                <span>{{ itemYP.countMoney? (itemYP.countMoney * itemYP.dosage).toFixed(2):0 }}</span>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="conTBox" style="margin-top:10px" v-if="mzPrescriptionCY.length > 0">
        <div>
          <div style="font-weight: bold;">成药处方</div>
        </div>
        <div v-for="(itemC,CY) in mzPrescriptionCYNames" :key="CY">
          处方名：<span>{{CY ? CY : '无'}}</span>
          <div v-for="(itemCY,indexCY) in itemC" :key="indexCY">
              <div>
                <span class="titleNameSelef">{{ itemCY.entityName?itemCY.entityName:'无'}},</span>
                <span style='margin:0 10px'>规格: <span>{{ itemCY.specification?itemCY.specification:'无'}}</span></span>
              </div>
              <div>
                <span v-if="itemCY.money">{{ itemCY.money ? itemCY.money.toFixed(2) :'无'}}/{{ itemCY.isSeparate ? itemCY.separateNumberUnit : itemCY.specificationUnit }}</span>
                <span style='margin:0 5px'>×</span>
                 <span>{{ itemCY.amount?itemCY.amount:'无' }}</span>
                 <span style='margin:0 5px' >=</span>
                 <span>{{ itemCY.countMoney?itemCY.countMoney.toFixed(2):0}}</span>
              </div>
              <div>
                <span>厂家: {{ itemCY.productFactory?itemCY.productFactory:'无' }}</span>
              </div>
          </div>
        </div>
    </div>
    <div class="conTBox" style="margin-top:10px" v-if="mzPrescriptionSYGroup.length > 0">
        <div>
          <div style="font-weight: bold;">输液处方</div>
        </div>
        <div v-for="(itemY,SY) in mzPrescriptionSYGroupNames" :key="SY">
          处方名：<span>{{SY ? SY : '无'}}</span>
          <div v-for="(itemSY,index) in itemY" :key="index">
              <div>
                <span class="titleNameSelef">{{ itemSY.entityName?itemSY.entityName:'无'}},</span>
                <span style='margin:0 10px'>规格:<span>{{itemSY.specification?itemSY.specification:'无'}}</span></span>
              </div>
              <div>
                <span v-if="itemSY.money">{{ itemSY.money ? itemSY.money.toFixed(2) :'无'}}/{{ itemSY.isSeparate ? itemSY.separateNumberUnit : itemSY.specificationUnit }}</span>
                <span style='margin:0 5px'>×</span>
                 <span>{{ itemSY.amount?itemSY.amount:'无' }}</span>
                 <span style='margin:0 5px' >=</span>
                 <span>{{ itemSY.countMoney?itemSY.countMoney.toFixed(2):0}}</span>
              </div>
              <div>
                <span>厂家: {{ itemSY.productFactory?itemSY.productFactory:'无' }}</span>
              </div>
          </div>
        </div>
    </div>
    <div class="conTBox" style="margin-top:10px" v-if="orderGrouped[99].length > 0">
        <div v-for="(item,index) in orderGrouped[99]" :key="index">
          <span class="titleName">{{item.entityName}}：</span><span>{{item.countMoney.toFixed(2)}}</span>
        </div>
    </div>
    <div class="conTBox" style="margin-top:10px">
        <div>
          <span class="titleName">订单编号：</span><span>{{detailInfo.orderNum}}</span>
        </div>
        <div>
          <span class="titleName">创建时间：</span><span>{{detailInfo.addTime | timefilters }}</span>
        </div>
        <div>
          <span class="titleName">付款时间：</span><span>{{detailInfo.paySuccessTime | timefilters }}</span>
        </div>
        <div style="text-align: right">
          <span class="titleName">总金额：</span><span style="color: red;font-size: 20px;">{{detailInfo.totalMoney ? detailInfo.totalMoney.toFixed(2) : '0.00'  }}元</span>
        </div>
    </div>
    <!-- 签名 -->
    <el-dialog title="签名" :visible.sync="esigndialogVisible" width="100%" :close-on-click-modal="false">
      <vue-esign style="border: 1px solid #ddd;" ref="esign" :isCrop="isCrop" :width="600" :height="200" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor"></vue-esign>
      <div style="margin-top: 10px">
        <div class="flexlr" v-if="UserSignImg">
          <el-checkbox v-model="useLast">使用上次签名 </el-checkbox>
          <img style="width: 100px; height: 40px" :src="CommonPath + UserSignImg" alt="" srcset="" />
        </div>
        <div style="margin-top: 10px">
          <el-button @click="handleReset">清空签名</el-button>
          <el-button @click="esigndialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleGenerate">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <div style="width:100%;height:100px"></div>
    <div class="btnSign" v-if="detailInfo.state == 1">
      <span type="primary" @click="toCompleteDrug()">完成备药</span>
    </div>
  </div>
</template>
<script>
import { Outpatient } from '@/components/DrugDomain/Outpatient'
import { Patient } from '@/components/HospitalDomain/Patient/Patient'
import { Organization } from '@/components/HospitalDomain/Organization'
import axios from 'axios'
export default {
  data() {
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug)
    var patient = new Patient(this.TokenClient, this.Services.Authorization)
    var organizationer = new Organization(this.TokenClient, this.Services.Authorization)
    return {
      OutpatientDomain: outpatient,
      patientDomain: patient,
      OrganizationDomain: organizationer,
      tableData: [],
      detailInfo: {
        gender: 0,
      },
      DialogTitle: '收费',
      setDialog: false,
      formLabelWidth: '100px',
      charge: {
        num: 12,
        type: 1,
        payNum: 12,
        change: 0,
      },
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
      orderId: this.$route.query.orderId,
      type: this.$route.query.type, //1收费2退费
      orderGrouped: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 88: [], 99: [] },
      patientId: 0,
      patientDiagnoseId: 0,
      patientInfo: {},
      patientDiagnoseInfo: {},
      mZPrescriptionInfo: {
        mzCheckItems: [],
        mzOtherCharges: [],
        mzPrescriptionOut: {
          mzPrescriptionSYGroup: [],
          mzPrescriptionCY: [],
          mzPrescriptionYP: [],
        },
      },
      mZPrintPrescription: {},
      isPrint: false,
      //moment: require('moment'),
      prescriptionGrouped: { 0: [], 1: [], 2: [] },
      path: this.CommonPath,
      isShow: false,
      totalSale: 0,
      totalFJ: 0,
      totalCY: 0,
      totalSY: 0,
      mzPrescriptionYP:[],
      mzPrescriptionYPNames:{},
      mzPrescriptionCY:[],
      mzPrescriptionCYNames:{},
      mzPrescriptionSYGroup:[],
      mzPrescriptionSYGroupNames:{},
      esigndialogVisible:false,
      isCrop: false, //是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      lineWidth: 6, //画笔粗细
      lineColor: '#000000', //画笔颜色
      bgColor: '', //画布背景色，为空时画布背景透明
      FileUploadUrl: this.CommonFilePath,
      imgurl: '', //签名生成的图片
      auditSignImg:'',
      useLast: false,
      UserSignImg: '',
    }
  },
  mounted() {
    if (this.type == 1) {
      this.paymentedDetail()
    } else {
      this.drugRefundDetail()
    }
  },
  methods: {
    getAuditSignImg() {
      var _this = this
      _this.OrganizationDomain.GetUserSign(
        function (data) {
          _this.UserSignImg = data.data
          _this.esigndialogVisible = true
        },
        function (error) {
          _this.esigndialogVisible = true
          // let jsonObj = JSON.parse(error.msg)
          // _this.$message({
          //   message: jsonObj.msg,
          //   type: 'error',
          // })
          console.log(error)
        }
      )
    },
    toCompleteDrug() {
      var _this = this
       _this.getAuditSignImg()
      // _this
      //   .$confirm('完成备药?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     // type: 'warning'
      //   })
      //   .then(() => {
      //     _this.getAuditSignImg()
      //   })
      //   .catch(() => {})
    },
        // 将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    setAuditSignImg() {
      var _this = this
      _this.OrganizationDomain.SetUserSign(
        this.auditSignImg,
        function (data) {
          _this.handleReset()
          _this.esigndialogVisible = false
          _this.saveCompleteDrug()
        },
        function (error) {
          let jsonObj = JSON.parse(error.msg)
          _this.$message({
            message: jsonObj.msg,
            type: 'error',
          })
          console.log(error)
        }
      )
    },
    handleGenerate() {
        let _this = this
      if (_this.useLast) {
        _this.auditSignImg = _this.UserSignImg
        _this.setAuditSignImg()
      } else {
        _this.$refs.esign
          .generate()
          .then((res) => {
            // 转成文件
            var blob = _this.dataURLtoBlob(res)
            var tofile = _this.blobToFile(blob, '签名.jpg')
            const formData = new FormData()
            setTimeout(async () => {
              formData.append('file', tofile, tofile.name)
              // formData.append('fileType', 9)
              // ajax 请求
              axios({
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer' + ' ' + JSON.parse(sessionStorage.getItem(this.ClientId + 'Token')).access_token },
                // 这里是你的上传地址
                url: _this.FileUploadUrl,
                data: formData,
              })
                .then((res) => {
                  _this.auditSignImg = res.data[0].completeFilePath
                  _this.setAuditSignImg()
                })
                .catch((err) => {
                  _this.$message.error('上传签名失败')
                })
            })
          })
          .catch((err) => {
            _this.$message.error('请签名之后提交！')
          })
      }
    },
    handleReset() {
      if (this.$refs.esign) {
        this.$refs.esign.reset()
      }
    },
    saveCompleteDrug() {
      var _this = this
      _this.OutpatientDomain.DrugCompleteOrg(
        _this.detailInfo.id,
        _this.auditSignImg,
        function (data) {
          _this.$message({
            message: '完成备药成功',
            type: 'success',
          })
          setTimeout(()=>{
            _this.$router.push("/Outpatient/ChargedListPhone");
          },1000)
        },
        function (error) {
          let jsonObj = JSON.parse(error.msg)
          _this.$message({
            message: jsonObj.msg,
            type: 'error',
          })
          console.log(error)
        }
      )
    },
    paymentedDetail() {
      var _this = this
      _this.OutpatientDomain.PaymentedDetail(
        this.orderId,
        function (data) {
          _this.detailInfo = data.data
          _this.patientId = _this.detailInfo.patientId
          _this.patientDiagnoseId = _this.detailInfo.patientDiagnoseId
          if (_this.patientId) {
            _this.getDetail()
            _this.getPatientDiagnose()
            _this.getMZPrescriptionDetail()
          }
          //orderType 0直接售药 1处方 2检查治疗项 3附加收费 4代煎费用 5审方费用 6快递费 7包装费 8药剂师审方费用
          _this.orderGrouped = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 88: [], 99: [] }
          if (_this.detailInfo.details.length > 0) {
            _this.detailInfo.details.map(({ orderType, ...rest }) => {
              _this.orderGrouped[orderType] = _this.orderGrouped[orderType] || []
              rest.orderType = orderType
              if ((orderType == 0 || orderType == 1) && _this.detailInfo.mzDrugOrgs) {
                let drugOrg = _this.detailInfo.mzDrugOrgs.filter((i) => i.id == rest.entityId)
                if (drugOrg[0]) {
                  rest.drugType = drugOrg[0].mzDrug.drugType
                  rest.specification = drugOrg[0].specification
                  rest.specificationUnit = drugOrg[0].specificationUnit
                  rest.productFactory = drugOrg[0].productFactory
                  rest.isSeparate = drugOrg[0].isSeparate
                  rest.separateNumber = drugOrg[0].separateNumber
                  rest.separateNumberUnit = drugOrg[0].separateNumberUnit
                  rest.remark = drugOrg[0].remark
                }
              }
              _this.orderGrouped[orderType].push(rest)
              if (orderType == 5 || orderType == 8) {
                _this.orderGrouped[88].push(rest)
              }

              if (orderType == 3 || orderType == 4 || orderType == 6 || orderType == 7) {
                _this.orderGrouped[99].push(rest)
              }
            })
          }
          if (_this.orderGrouped[0].length > 0) {
            _this.totalSale = _this.orderGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
          _this.prescriptionGrouped = { 0: [], 1: [], 2: [], 3: [] }
          //prescriptionType 0方剂处方 1成药处方 2输液处方
          if (_this.orderGrouped[1].length > 0) {
            _this.orderGrouped[1].map(({ prescriptionType, ...rest }) => {
              _this.prescriptionGrouped[prescriptionType] = _this.prescriptionGrouped[prescriptionType] || []
              rest.prescriptionType = prescriptionType
              _this.prescriptionGrouped[prescriptionType].push(rest)
            })
          }
          if (_this.prescriptionGrouped[0].length > 0) {
            _this.totalFJ = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney * i.dosage, 0).toFixed(2)
          }

          if (_this.prescriptionGrouped[1].length > 0) {
            _this.totalCY = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
          if (_this.prescriptionGrouped[2].length > 0) {
            _this.totalSY = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
          			//prescriptionType 整合处方 0方剂处方 1成药处方 2输液处方
							if (_this.orderGrouped[1].length > 0) {
								_this.orderGrouped[1].map(({
									prescriptionType,
									...rest
								}) => {
									_this.prescriptionGrouped[prescriptionType] = _this.prescriptionGrouped[
										prescriptionType] || [];
									rest.prescriptionType = prescriptionType;
									_this.prescriptionGrouped[prescriptionType].push(rest);
								});
							}

							_this.mzPrescriptionYP = _this.orderGrouped[1].filter(obj => obj.prescriptionType ===
								0);
							_this.mzPrescriptionYP.map(({
								prescriptionName,
								...itemMzPrescriptionYP
							}) => {
								_this.mzPrescriptionYPNames[prescriptionName] = _this
									.mzPrescriptionYPNames[
										prescriptionName] || [];
								itemMzPrescriptionYP.prescriptionName = prescriptionName;
								_this.mzPrescriptionYPNames[prescriptionName].push(itemMzPrescriptionYP);
							});

							_this.mzPrescriptionCY = _this.orderGrouped[1].filter(obj => obj.prescriptionType ===1);
							_this.mzPrescriptionCY.map(({
								prescriptionName,
								...itemMzPrescriptionCY
							}) => {
								_this.mzPrescriptionCYNames[prescriptionName] = _this
									.mzPrescriptionCYNames[
										prescriptionName] || [];
								itemMzPrescriptionCY.prescriptionName = prescriptionName;
								_this.mzPrescriptionCYNames[prescriptionName].push(itemMzPrescriptionCY);
							});
							_this.mzPrescriptionSYGroup = _this.orderGrouped[1].filter(obj => obj.prescriptionType === 2);
							_this.mzPrescriptionSYGroup.map(({
								prescriptionName,
								...itemMzPrescriptionSY
							}) => {
								_this.mzPrescriptionSYGroupNames[prescriptionName] = _this.mzPrescriptionSYGroupNames[prescriptionName] || [];
								itemMzPrescriptionSY.prescriptionName = prescriptionName;
								_this.mzPrescriptionSYGroupNames[prescriptionName].push(itemMzPrescriptionSY);
							});
              console.log(_this.mzPrescriptionYPNames)

        },
        function (err) {
          console.log(err)
        }
      )
    },
    /**
     * 已退费详情
     */
    drugRefundDetail() {
      var _this = this
      _this.OutpatientDomain.DrugRefundDetail(
        this.orderId,
        function (data) {
          _this.detailInfo = data.data
          _this.patientId = _this.detailInfo.patientId
          _this.patientDiagnoseId = _this.detailInfo.patientDiagnoseId
          if (_this.patientId) {
            _this.getDetail()
            _this.getPatientDiagnose()
            _this.getMZPrescriptionDetail()
          }
          _this.orderGrouped = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 88: [], 99: [] }
          if (_this.detailInfo.details.length > 0) {
            _this.detailInfo.details.map(({ orderType, ...rest }) => {
              _this.orderGrouped[orderType] = _this.orderGrouped[orderType] || []
              rest.orderType = orderType
              if ((orderType == 0 || orderType == 1) && _this.detailInfo.mzDrugOrgs) {
                let drugOrg = _this.detailInfo.mzDrugOrgs.filter((i) => i.id == rest.entityId)
                rest.drugType = drugOrg[0].mzDrug.drugType
                rest.specification = drugOrg[0].specification
                rest.specificationUnit = drugOrg[0].specificationUnit
                rest.productFactory = drugOrg[0].productFactory
                rest.isSeparate = drugOrg[0].isSeparate
                rest.separateNumber = drugOrg[0].separateNumber
                rest.separateNumberUnit = drugOrg[0].separateNumberUnit
              }
              _this.orderGrouped[orderType].push(rest)
              if (orderType == 5 || orderType == 8) {
                _this.orderGrouped[88].push(rest)
              }

              if (orderType == 3 || orderType == 4 || orderType == 6 || orderType == 7) {
                _this.orderGrouped[99].push(rest)
              }
            })
          }
          if (_this.orderGrouped[0].length > 0) {
            _this.totalSale = _this.orderGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
          _this.prescriptionGrouped = { 0: [], 1: [], 2: [], 3: [] }
          //prescriptionType 0方剂处方 1成药处方 2输液处方
          if (_this.orderGrouped[1].length > 0) {
            _this.orderGrouped[1].map(({ prescriptionType, ...rest }) => {
              _this.prescriptionGrouped[prescriptionType] = _this.prescriptionGrouped[prescriptionType] || []
              rest.prescriptionType = prescriptionType
              _this.prescriptionGrouped[prescriptionType].push(rest)
            })
          }
          if (_this.prescriptionGrouped[0].length > 0) {
            _this.totalFJ = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney * i.dosage, 0).toFixed(2)
          }
          if (_this.prescriptionGrouped[1].length > 0) {
            _this.totalCY = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
          if (_this.prescriptionGrouped[2].length > 0) {
            _this.totalSY = _this.prescriptionGrouped[0].reduce((sum, i) => sum + i.countMoney, 0).toFixed(2)
          }
        },
        function (err) {
          console.log(err)
        }
      )
    },
    getDetail() {
      var _this = this
      _this.patientDomain.GetDetail(
        _this.patientId,
        function (data) {
          _this.patientInfo = data.data
        },
        function (err) {}
      )
    },
    getPatientDiagnose() {
      var _this = this
      _this.patientDomain.GetPatientDiagnoseDetail(
        _this.patientDiagnoseId,
        function (data) {
          _this.patientDiagnoseInfo = data.data
        },
        function (err) {}
      )
    },
    getMZPrescriptionDetail() {
      var _this = this
      _this.OutpatientDomain.MZPrescriptionDetail(
        _this.patientDiagnoseId,
        function (data) {
          _this.mZPrescriptionInfo = data.data
          _this.getPrintPrescription()
        },
        function (err) {}
      )
    },
    getPrintPrescription() {
      var _this = this
      _this.patientDomain.MZPrintPrescription(
        _this.patientDiagnoseId,
        this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditUserId ? this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditUserId : this.mZPrescriptionInfo.mzPrescriptionOut.userId,
        this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditPharmacistId,
        function (data) {
          _this.mZPrintPrescription = data.data
        },
        function (err) {}
      )
    },
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped lang="scss">
.iq-card-body {
  padding: 0 0 15px;
  height: auto;

  .table-top {
    width: 96%;
    margin: 0 auto;
  }

  .table-line {
    width: 100%;
    height: 6px;
    background: #f5f6f7;
    margin: 0 0 15px;
  }

  .table-content {
    padding: 0 40px;

    .top-info {
      .t1 {
        margin-right: 30px;
      }

      .t2 {
        color: #999999;
      }

      .center-i {
        // margin: 0 40px;
      }

      .right-img {
        margin-right: 10%;
      }

      .info-div {
        margin-top: 10px;
      }
    }

    .title {
      height: 60px;
      line-height: 60px;
      font-weight: bold;
    }

    ::v-deep .el-table__row > td {
      /* 去除表格线 */
      border: none !important;
    }

    ::v-deep .el-table th.is-leaf {
      /* 去除上边框 */
      border: none !important;
    }

    ::v-deep .el-table::before {
      /* 去除下边框 */
      height: 0 !important;
    }

    .print-d {
      ::v-deep .printTab .el-table__body-wrapper .el-table__cell {
        padding: 2px 0 !important;
      }
    }

    ::v-deep .el-table .el-table__body-wrapper .el-table__cell {
      padding: 10px 0 !important;
    }

    .my-table {
      border: 1px solid #ebeef5;
      padding: 10px 5px;
    }

    .el-form-item .el-form-item {
      margin-bottom: 20px;
    }

    .leftInput {
      width: 100%;
      position: relative;
    }

    .rightTip {
      position: absolute;

      top: 0;
      z-index: 2;
      color: #999999;
    }

    ::v-deep .el-input-number .el-input__inner {
      text-align: left;
    }

    .numDiv {
      padding: 15px;
      background: #fafafa;
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      margin: 20px 0;

      .right-num {
        // margin-right: 10%;
      }

      .center-num {
        // margin: 0 20px;
      }

      .desc {
        margin-right: 2%;
        width: 32%;
      }

      .desc:nth-child(3n) {
        margin-right: 0;
      }

      .type0 {
        color: #67c23a !important;
      }

      .type1 {
        color: #f56c6c !important;
      }

      .type2 {
        color: #e6a23c !important;
      }

      .t1 {
        margin-right: 20px;
      }

      .t2 {
        color: #999999;
      }

      .t3 {
        color: #fe0000;
      }

      .num1 {
        margin: 0 10px;
      }

      ::v-deep .num2 .el-input__inner {
        color: #ff0000;
      }

      .inputNum {
        color: #ff0000;
      }
    }

    .numDiv2 {
      padding: 15px;
      background: #fff7f7;
      border: 1px solid #f4d3d3;
      border-radius: 8px;
      margin: 20px 0;

      .num1 {
        margin: 0 10px;
      }

      .num2 {
        color: #ff0000;
      }

      ::v-deep .num2 .el-input__inner {
        color: #ff0000;
      }

      .inputNum {
        color: #ff0000;
      }
    }

    .infoDiv {
      // margin: 0 20px;

      .t1 {
        margin-right: 20px;
      }

      .t2 {
        color: #5c83f2;
      }
    }
  }
}

.PrintBox {
  width: 600px;
  background: #ffffff;
  font-size: 14px;
  padding: 20px;
  page-break-after: always !important;
  color: #333333;
}

.PrintBoxTitle {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}

.PrintBoxTitle1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PrintBoxTitle2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.PrintBoxTitleLine {
  width: 100%;
  height: 1px;
  background: #666666;
  margin: 8px 0 0 2px;
  // margin-top: -2px;
  margin-right: 10px;
}

.PrintBoxTitleLineD {
  margin: 15px 0;
  border-bottom: 1px dashed #999999;
}

.printBox {
  visibility: visible !important;
  background-color: #adadad;
  color: #333333;
}

.printBox2 {
  visibility: visible !important;
  color: #333333;
}

.printBox3 {
  visibility: visible !important;
  color: #333333;
}

.print-d {
  width: 90%;
  margin: 0 auto;
  background: #ffffff;
  font-size: 14px;

  .p-t {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 20px;
    color: #333333;
  }

  .oneLine {
    margin: 10px 0 0 0;
    border-bottom: 1px dashed #999999;
  }

  .oneLine2 {
    margin: 10px 0;
    border-bottom: 1px solid #999999;
  }

  .oneLine3 {
    margin: 10px 0;
    border-bottom: 1px dashed #999999;
  }

  .twoLine {
    margin: 10px 0;
    height: 3px;
    border-top: 1px dashed #999999;
    border-bottom: 1px dashed #999999;
  }
}
.topBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #3F7EE9;
  font-size: 18px;
  color: #FFFFFF;
  padding: 15px 25px;

}
.conTBox {
  background: #ffffff;
  font-size: 18px;

  padding: 30px 15px;
}
.userName {
  color: #3F7EE9;
}
.titleName{
  font-size: 18px;
  color: #999999;
}
.titleNameSelef {
  color: #3F7EE9;
}
  .btnSign {
    margin-top: 1vh;
    width: 95%;
    padding: 10px 0;
    border-radius: 20px;
    background: #3F7EE9;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    border: none;
    position: fixed;
    bottom: 10px;
    margin-left: 2.5%;
  }
  .flexlr {
    display: flex;
    align-items: center;
  }
</style>
